import { LoyaltyStatus } from '../redux/appState'
import { UserProfile } from './types'

export const VIETNAM_COUNTRY_CODE3 = 'VNM'

export const isVietnamClient = (userProfile: UserProfile | null | undefined): boolean =>
    userProfile?.country?.code3 === VIETNAM_COUNTRY_CODE3

export const isThinkRewardsAvailable = (
    loyaltyStatus: LoyaltyStatus | null | undefined,
    userProfile: UserProfile | null | undefined,
): boolean => loyaltyStatus === 'active' && !!userProfile && !isVietnamClient(userProfile)
